// can't depend on existing shared lib for formatting; is quite minor aspect of this lib
export function percentageFormatter(value: number | null | undefined) {
  if (typeof value === 'number') {
    return `${(value * 100).toFixed(2)}%`
  } else {
    return '-'
  }
}
